import {Box, IconButton, Stack, Typography} from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import {highlightText} from "../../../../utils/uiUtils";

const orderState = [
    {key: "draft", value: "Draft", substates: []},
    {
        key: "shipment", value: "Shipment", substates: [
            {key: "preparing_for_shipment", value: "Preparing for Shipment"},
            {key: "courier_en_route", value: "Courier En route"},
            {key: "shipment_collected", value: "Shipment Collected"},
            {key: "out_for_delivery", value: "Out for delivery"},
            {key: "verified_and_completed", value: "Verified & Completed"},
        ]
    },
    {
        key: "processing", value: "Processing", substates: [
            {key: "audit_started", value: "Audit Started"},
            {key: "audit_complete", value: "Audit Complete"},
            {key: "ingestion_started", value: "Ingestion Started"},
            {key: "ingestion_complete", value: "Ingestion Complete"},
        ]
    },
];

const calculateProgress = (currentState, activeSubstate) => {
    if (activeSubstate === "draft" || activeSubstate === "request_received") return 0;
    const activeState = orderState.find(state => state.substates.some(s => s.key === activeSubstate));
    const activeSubstateIndex = activeState?.substates.findIndex(s => s.key === activeSubstate);
    const activeTotalIndex = activeState?.substates?.length;
    if (activeState?.key === "processing") {
        if (currentState === "shipment") return 100;
        return ((activeSubstateIndex + 1) / activeTotalIndex) * 100;
    }
    if (activeState?.key === "shipment") {
        if (currentState === "processing") return 0;
        return ((activeSubstateIndex + 1) / activeTotalIndex) * 100;
    }
    return 0;
};

export const mapShippingModeText = (mode) => {
    const map = {self: "Self", tapeark: "Tape Ark", none: "None"};
    return map[mode] ?? mode;
};

export const getParentStageLabel = (state) => {
    if (state === "draft") return "Draft";
    for (const s of orderState) {
        if (s.substates.some(sub => sub.key === state)) return s.value;
    }
    return null;
};

export const getStateLabel = (state) => {
    if (state === "draft") return "Draft";
    if (state === "request_received") return "Request Received";
    for (const s of orderState) {
        const sub = s.substates.find(sub => sub.key.toLowerCase() === state);
        if (sub) return sub.value;
    }
    return state;
};

const CustomLinearProgress = ({value, label}) => (
    <Box sx={{minWidth: "120px", width: "100%", margin: "auto", borderRadius: "4px", backgroundColor: "#565656", overflow: "hidden", position: "relative"}}>
        <Box sx={{width: `${value}%`, height: "22px", backgroundColor: "#5D8150", borderRadius: "inherit"}}/>
        <Box sx={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", color: "white", width: "100%", zIndex: 1}}>
            <Typography sx={{fontFamily: "Poppins", fontSize: "14px", fontWeight: value > 0 ? 700 : 400, color: value > 0 ? "#FFFFFF" : "#ACACAC"}} variant="body2">
                {label}
            </Typography>
        </Box>
    </Box>
);

export const renderOrderCell = (row, searchQuery) => (
    <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Typography sx={{color: "#FFFFFF", fontSize: 18, fontFamily: "Poppins", whiteSpace: "pre"}}>
            {highlightText(row.tapeark_identifier ? `${row.order_number} (${row.tapeark_identifier})` : row.order_number, searchQuery)}
        </Typography>
        <Typography sx={{color: "#656565", fontSize: 14, fontFamily: "Poppins", whiteSpace: "pre"}}>
            {highlightText(row.customer_name, searchQuery)}
        </Typography>
    </Box>
);

export const renderOrderStatus = (row) => (
    <Stack direction="column" spacing={1} sx={{py: 1, pr: 2}}>
        {orderState
            .filter(s => s.key !== "draft" && s.key !== "request_received")
            .map(state => (
                <CustomLinearProgress key={state.key} value={calculateProgress(state.key, row.status)} label={state.value}/>
            ))}
    </Stack>
);

const itemSx = {display: 'flex', flexDirection: 'column', alignItems: 'center'};

export const renderOrderActions = (row, {handleManage, handleEdit, handleDelete} = {}) => (
    <>
        <Box sx={itemSx}>
            <IconButton onClick={() => handleManage && handleManage(row)}>
                <AccountTreeOutlinedIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>
            </IconButton>
            <Typography sx={{color: '#FFFFFF', fontSize: 12}}>Manage</Typography>
        </Box>
        <Box sx={itemSx}>
            <IconButton onClick={() => handleEdit && handleEdit(row)}>
                <EditOutlinedIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>
            </IconButton>
            <Typography sx={{color: '#FFFFFF', fontSize: 12}}>Edit</Typography>
        </Box>
        <Box sx={itemSx}>
            <IconButton onClick={() => handleDelete && handleDelete(row)}>
                <DeleteIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>
            </IconButton>
            <Typography sx={{color: '#FFFFFF', fontSize: 12}}>Delete</Typography>
        </Box>
    </>
);
